/* eslint-disable */

/**
 * Document type
 */
export enum FinnairBoardingPassDocumentType {
  PDF = 'PDF',
  APPLE_WALLET = 'APPLE_WALLET'
}

